<template>
  <header class="adminHeader">
    <nav class="adminHeaderNavegacao" aria-label="Navegação administrativa">
      <router-link
        to="/"
        exact
        class="adminHeaderItem"
        title="Início"
      >
        <i class="fa fa-home" aria-hidden="true"></i>
        <span>Início</span>
      </router-link>
      <router-link
        to="/fav"
        class="adminHeaderItem"
        title="Favoritos"
      >
        <i class="fa fa-star-o" aria-hidden="true"></i>
        <span>Favoritos</span>
      </router-link>
      <router-link
        v-if="podeVerEventos"
        to="/eventos"
        class="adminHeaderItem"
        title="Eventos"
      >
        <i class="fa fa-calendar" aria-hidden="true"></i>
        <span>Eventos</span>
      </router-link>
      <router-link
        v-if="podeVerSessoes"
        to="/sessoes"
        class="adminHeaderItem"
        title="Sessões"
      >
        <i class="fa fa-exchange" aria-hidden="true"></i>
        <span>Sessões</span>
      </router-link>
      <router-link
        v-if="isAdmin"
        to="/admin"
        exact
        class="adminHeaderItem"
        title="Administração"
      >
        <i class="fa fa-users" aria-hidden="true"></i>
        <span>Administração</span>
      </router-link>
      <router-link
        v-if="tipoUsuarioNormalizado !== 'Degustacao'"
        to="/meus-dados"
        class="adminHeaderItem"
        title="Meus dados"
      >
        <i class="fa fa-user-circle-o" aria-hidden="true"></i>
        <span>Meus dados</span>
      </router-link>
      <button
        type="button"
        class="adminHeaderSair"
        title="Sair"
        @click="sair"
      >
        <i class="fa fa-sign-out" aria-hidden="true"></i>
        <span>Sair</span>
      </button>
    </nav>
  </header>
</template>

<script>
export default {
  name: "HeaderAdminWeddbets",
  computed: {
    tipoUsuario() {
      return this.$sessao && this.$sessao.usuario
        ? this.$sessao.usuario.tipoUsuario
        : "";
    },
    tipoUsuarioNormalizado() {
      return this.tipoUsuario
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },
    isAdmin() {
      return (
        this.tipoUsuario == "Administrador" ||
        this.tipoUsuario == "Administrador Site"
      );
    },
    isAdminSite() {
      return this.tipoUsuario == "Administrador Site";
    },
    podeVerEventos() {
      return (
        (this.isAdmin || this.tipoUsuario == "Apresentador") &&
        !this.isAdminSite
      );
    },
    podeVerSessoes() {
      return this.isAdmin || this.tipoUsuario == "Apresentador";
    },
  },
  methods: {
    sair() {
      localStorage.removeItem("ckd");
      localStorage.removeItem("ckdCch");
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.adminHeader {
  align-items: stretch;
  background: #3f464d;
  border-bottom: 1px solid #535c64;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  display: flex;
  height: 52px;
  justify-content: space-between;
  left: 50%;
  max-width: 1180px;
  padding: 0 18px;
  position: fixed;
  right: auto;
  top: 10px;
  transform: translateX(-50%);
  width: calc(100% - 32px);
  z-index: 1040;
}

.adminHeaderNavegacao {
  display: flex;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: none;
}

.adminHeaderNavegacao::-webkit-scrollbar {
  display: none;
}

.adminHeaderItem,
.adminHeaderSair {
  align-items: center;
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: #e4e8eb;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 600;
  gap: 7px;
  height: 52px;
  letter-spacing: 0;
  padding: 0 14px;
  text-decoration: none;
  white-space: nowrap;
}

.adminHeaderItem i,
.adminHeaderSair i {
  font-size: 14px;
  width: 15px;
}

.adminHeaderItem:hover,
.adminHeaderSair:hover {
  background: #4d555d;
  color: #ffffff;
  text-decoration: none;
}

.adminHeaderItem.router-link-active {
  background: #495159;
  border-bottom-color: #e3ad55;
  color: #ffffff;
}

.adminHeaderSair {
  cursor: pointer;
}

@media (max-width: 767px) {
  .adminHeader {
    padding: 0 6px;
    width: calc(100% - 12px);
  }

  .adminHeaderItem,
  .adminHeaderSair {
    gap: 5px;
    padding-left: 10px;
    padding-right: 10px;
  }

}
</style>
